import React from "react";
import styled from "styled-components";
import furnaceBackgroundImage from "images/background-glass-seals-2.jpg";

const GlassSealsHero = styled.div`
  background-image: url('${furnaceBackgroundImage}');
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;

`;

const TransparencyHero = styled.div`
  background: rgba(54, 54, 54, 0.8) !important;
`;

const GlassSealsFeature = () => (
  <GlassSealsHero className="hero is-fullheight is-dark">
    <div className="columns">
      <div className="column is-two-fifths-widescreen is-offset-three-fifths-widescreen is-offset-one-fifth-desktop is-four-fifths-desktop is-12-touch">
        <TransparencyHero className="hero is-fullheight is-dark">
          <div className="hero-body">
            <div className="container">
              <div className="columns">
                <div className="column is-offset-1 is-10">
                  <h1 className="title is-1" style={{ marginTop: "1rem" }}>
                    Hermetic Seals
                  </h1>
                  <h2 className="subtitle is-4">
                    Airtight, Glass-to-Metal Bonding
                  </h2>
                  <hr />
                  <p>
                    Since 1964, creating precision-machined, hermetically sealed
                    connectors has been the heart of our business. After a
                    connector housing has been machined and thoroughly
                    inspected, it is sent to assembly, where pins and glass
                    insulators are carefully added. We send the fully assembled
                    parts through our CalAlloy furnace, where the glass bonds to
                    the metal on a molecular level, creating an airtight seal
                    capable of passing a helium leak rate of 1x10<sup>-8</sup>.
                  </p>
                  <br />
                  <p>
                    Since we machine our parts out of specialized metals like
                    Kovar™—which has a coefficient of thermal expansion (CTE)
                    identical to that of glass—tension during the sealing
                    process is minimized as the bond between glass and metal is
                    strengthened, leading to minimal chance of breakage. We also
                    perform compression sealing using metals like Inconel, whose
                    differing CTE allows the metal to compress around the glass
                    as it cools, leading to a robust seal ideal for high stress,
                    extreme environments.
                  </p>
                  <br />
                  <p>
                    We don't limit ourselves to a single product line—we build
                    you <em>your</em> product, exactly the way you want it
                    built. Whatever the part that needs to be sealed, we can do
                    it, quickly and reliably. That's why you'll find our seals
                    in a wide variety of products worldwide and beyond—including
                    most NASA launches since Gemini II.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </TransparencyHero>
      </div>
    </div>
  </GlassSealsHero>
);

export default GlassSealsFeature;



// WEBPACK FOOTER //
// ./src/pages/GlassSeals/GlassSealsFeature.js